import { Role } from '~/common/providers/auth/role';

export const planningAllowedRoles: Role[] = [
  'LOGLASS_SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CORP_PLANNING',
  'MANAGER',
];
